import { ValidationAction } from '../../enums/validation-task/validation-action';
import { ValidationMethod } from '../../enums/validation-task/validation-method';
import { ValidationConfigTypes } from '../../types/validation-config-types';
import { DestinationTaskConfigBase } from '../config-objects/destination-service-config-base';

/**
 * Configuration for a Validation task — validates records against field-level rule sets.
 * Failures either stop immediately (StopOnTheFirstRecordWithAnError) or are collected
 * across all records (ValidateAllRecords). Error messages can optionally be written
 * to a processingData field instead of throwing immediately.
 */
export class ValidationConfig extends DestinationTaskConfigBase {
	/**
	 * Controls when validation failures cause the flow to stop.
	 * StopOnTheFirstRecordWithAnError=0, ValidateAllRecords=1.
	 * @default ValidationAction.StopOnTheFirstRecordWithAnError
	 */
	validationAction: ValidationAction = ValidationAction.StopOnTheFirstRecordWithAnError;

	/**
	 * When true, error messages are written to errorField on each record.
	 * The flow still throws at the end based on validationAction.
	 * @default false
	 */
	mapErrorMessage = false;

	/**
	 * Dot-notation path in processingData where the error message is written
	 * when mapErrorMessage=true. Required if mapErrorMessage=true.
	 * @default ''
	 */
	errorField = '';

	/**
	 * Validation strategy. Currently only CustomRules=0 is supported.
	 * @default ValidationMethod.CustomRules
	 */
	validationMethod: ValidationMethod = ValidationMethod.CustomRules;

	/**
	 * Validation rule configuration. For CustomRules, this is a CustomRules object
	 * containing an array of FieldRuleSets. Required at runtime.
	 */
	validationConfig?: ValidationConfigTypes;

	constructor(init?: Partial<ValidationConfig>) {
		super(init);
		if (init) {
			Object.assign(this, init);
		}
	}
}
